import ProtectedRoute from '../auth/ProtectedRoute';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import { Root } from '../components/Root';
import { AboutPage } from '../pages/AboutPage';
import { JobsPage } from '../pages/JobsPage';
import { JobPage } from '../pages/JobPage';
import { FilePage } from '../pages/FilePage';
import { ErrorPage } from '../pages/ErrorPage';
import { LoggedOutPage } from '../pages/LoggedOutPage';
import { AccessDeniedPage } from '../pages/AccessDeniedPage';
import { AdminPage } from '../pages/AdminPage';
import { DownloadProgressProvider } from '../context/DownloadFileContext';
const isTestEnv = process.env.REACT_APP_CI === 'true';

export const router = createBrowserRouter([
  {
    path: '/',
    element: isTestEnv? <Root/>: <ProtectedRoute><Root/></ProtectedRoute>,
    children: [
      {
        index: true,
        element: <Navigate to="/jobs" />
      },
      {
        path: 'jobs', 
        element: <DownloadProgressProvider><JobsPage/></DownloadProgressProvider>
      },
      {
        path: 'jobs/:id',
        element: <DownloadProgressProvider><JobPage /></DownloadProgressProvider>
      },
      {
        path: 'files/:id',
        element: <FilePage />
      },
      {       
        path: 'about',
        element: <AboutPage/>
      },
      {
        path: 'admin',
        element: <AdminPage/>,
      },
      {
        path: "*",
        element: <ErrorPage/>
      }
    ]
  },
  {
    path: '/logged_out',
    element: <LoggedOutPage />
  },
  {
    path: '/access-denied',
    element: <AccessDeniedPage />
  }
]);